module.exports = __webpack_public_path__ + "img/08_noff_open_L2.e2243c3d.svg";